import React, {useState} from 'react'
import AsyncSelect from 'react-select/async'
import PropTypes from 'prop-types'

import {fetchApplications} from '../../utils/services'
import PapiApplication from './PapiApplication'
import LoadingIndicator from '../shared/LoadingIndicator'
import DropdownIndicator from '../shared/DropdownIndicator'
import FloatingLabel from '../shared/FloatingLabel'
import useFocussedPlaceholder from '../../utils/useFocussedPlaceholder'
import {CLASSNAME, CLASSNAME_PREFIX, componentClassName, isRequiredClassName} from '../constants'

const renderItem = (item, size, showLink) => (
    <PapiApplication application={item} size={size} showLink={showLink} />
)

const renderValue =
    (size, showLink) =>
    ({children}) =>
        renderItem(children.props.application, size, showLink)

const PapiApplicationSelect = (props) => {
    const [originalPlaceholder] = useState(props.placeholder)

    const {
        title,
        outlined,
        value,
        isRequired,
        size,
        isOwner,
        showLink = false,
        showOptionLink = false,
        customFields,
        tokenProvider,
        profileApiUrl
    } = props

    const {isFocussed, placeholder, handleOnFocus, handleOnBlur} = useFocussedPlaceholder(
        false,
        originalPlaceholder || title,
        isRequired
    )

    const loadOptions = async (input) =>
        fetchApplications(input, isOwner, customFields, tokenProvider, profileApiUrl)

    return (
        <div className={`papi-react ${isRequiredClassName({isRequired, value})}`}>
            <div className={componentClassName(outlined)}>
                <FloatingLabel
                    title={title}
                    value={value}
                    isFocussed={isFocussed}
                    isRequired={isRequired}
                    hasCustomPlaceholder={!!originalPlaceholder}
                />
                <AsyncSelect
                    id="application-select"
                    placeholder={placeholder}
                    className={CLASSNAME}
                    classNamePrefix={CLASSNAME_PREFIX}
                    getOptionLabel={(option) => renderItem(option, size, showOptionLink)}
                    getOptionValue={(option) => option.id}
                    loadOptions={loadOptions}
                    defaultOptions={[]}
                    openMenuOnFocus={false}
                    openMenuOnClick={false}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                    closeMenuOnSelect
                    cacheOptions
                    components={{
                        LoadingIndicator,
                        SingleValue: renderValue(size, showLink),
                        MultiValueLabel: renderValue(size, showLink),
                        DropdownIndicator
                    }}
                    {...props}
                />
            </div>
        </div>
    )
}

PapiApplicationSelect.displayName = 'PapiApplicationSelect'

PapiApplicationSelect.propTypes = {
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    outlined: PropTypes.bool,
    isRequired: PropTypes.bool,
    isOwner: PropTypes.bool,
    isMulti: PropTypes.bool,
    showLink: PropTypes.bool,
    showOptionLink: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large', 'x-large']),
    customFields: PropTypes.string
}

export default PapiApplicationSelect
